/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync>): BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync(), model);
        BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync>): BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync.newInstance(<BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
